// src/features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import {
  GetSingleUserDetails,
  UserLoginUser,
  UserRegistrationUser,
} from './user_authServiceSync';

const initialState = {
  loading: false,
  user: null,
  token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
  error: null,
};

const user_authSlice = createSlice({
  name: 'user_auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem('admin_token');
      toast.info('Logged out successfully');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserLoginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UserLoginUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.user = payload?.data?.admin;
        state.token = payload?.data.token;
      })
      .addCase(UserLoginUser.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(UserRegistrationUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UserRegistrationUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.user = payload?.data?.admin;
      })
      .addCase(UserRegistrationUser.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(GetSingleUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleUserDetails.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.user = payload.data;
      })
      .addCase(GetSingleUserDetails.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { logout } = user_authSlice.actions;
export default user_authSlice.reducer;
